
export const CONSTANT = {
  DEFAULT_MOBILE_SIDE_HTML_WIDTH_PERCENT: 100,
  DEFAULT_DESKTOP_SIDE_HTML_WIDTH_PERCENT: 24,
  DEFAULT_MOBILE_SIDE_HTML_ALIGNMENT: "Top Aligned",
  DEFAULT_DESKTOP_SIDE_HTML_ALIGNMENT: "Left Aligned",
  MATCHES_MOBILE_WIDTH: "(max-width:1032px)",
  NO_RESULTS_FOUND: "No results found",
  NO_PLAN_DETAILS: "No plan details available",
  MOBILE_WIDTH_TEMPLATE: "(max-width:[mobileBreakpoint]px)",
};

export const CoverageSortBy = {
  Lives_Descending: 1,
  Alphabetical: 2,
};

// Hierarchy field mapping
export const HIERARCHY_FIELD_MAPPING = {
  "controller/payer level": {ResultName: "ControllerName", ShortName: "Payer"},
  "medical group level": {ResultName: "MedicalGroupName", ShortName: "Medical Group"}, 
  "formulary level": {ResultName: "FormularyName", ShortName: "Formulary Group"},
  "plan level": {ResultName: "PlanName", ShortName: "Plan"}
};